var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "car-oil@1x-a",
          d:
            "M10.9652778,7.42397143 C11.3728333,7.42397143 11.7041667,7.75868571 11.7041667,8.17118571 C11.7041667,8.5829 11.3728333,8.91761429 10.9652778,8.91761429 L10.9652778,8.91761429 L10.0716111,8.91761429 L10.0716111,10.1810429 L12.7183889,10.1810429 L13.7380556,11.0531857 L20.3888333,8.15075714 L21.5041667,9.27747143 C21.7927222,9.56897143 21.7927222,10.0411857 21.5041667,10.3334714 C21.2156111,10.6249714 20.7473889,10.6249714 20.4588333,10.3334714 L20.4588333,10.3334714 L20.0536111,9.92332857 L18.6201667,10.5487571 L14.8502778,17.9996857 L3.77394444,17.9996857 L3.77394444,14.6109 L0.999611111,14.6109 L0.999611111,10.1810429 L8.59305556,10.1810429 L8.59305556,8.91761429 L7.70016667,8.91761429 C7.29183333,8.91761429 6.96127778,8.5829 6.96127778,8.17118571 C6.96127778,7.75868571 7.29183333,7.42397143 7.70016667,7.42397143 L7.70016667,7.42397143 Z M16.4906111,11.4782571 L13.4829444,12.7904 L12.1778333,11.6746857 L5.25172222,11.6746857 L5.25172222,16.5068286 L13.9465,16.5068286 L16.4906111,11.4782571 Z M21.07576,11.7786286 L22.32456,13.6189143 C22.77496,14.2814857 22.70856,15.1823429 22.16776,15.7617714 C21.87656,16.0746286 21.48856,16.2460571 21.07576,16.2460571 C20.66296,16.2460571 20.27576,16.0746286 19.98376,15.7617714 C19.44296,15.1823429 19.37736,14.2814857 19.82696,13.6189143 L19.82696,13.6189143 L21.07576,11.7786286 Z M21.07576,13.7714857 L20.71176,14.3080571 C20.58056,14.5009143 20.59976,14.7640571 20.75736,14.9329143 C20.84296,15.0237714 20.95576,15.0743429 21.07576,15.0743429 C21.19576,15.0743429 21.30936,15.0237714 21.39416,14.9329143 C21.55176,14.7640571 21.57096,14.5009143 21.43976,14.3080571 L21.43976,14.3080571 L21.07576,13.7714857 Z M3.77394444,11.6746857 L2.47816667,11.6746857 L2.47816667,13.1180429 L3.77394444,13.1180429 L3.77394444,11.6746857 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "xlink:href": "#car-oil@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }